module.exports = __webpack_public_path__ + "static/media/instagram.485aabce.svg";